module.exports = __webpack_public_path__ + "img/Platine_0004_5.61f46af0.png";